/** @format */

import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { user_data } from "../../../../components/functions/usr";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";

const OQJAR_TABLE_ID = "oqjarQizilqishloqTable";
const OQJAR_EXPORT_NAME = "Oqjar Qizilqishloq";
const OQJAR_TABLE_TITLE =
  "Sirdaryo va kanallardagi suv sarflari hamda Qayroqqum suv omboriga suvning kelishi va chiqishi";
const MONTH_SHORT_NAMES = [
  "yan",
  "fev",
  "mar",
  "apr",
  "may",
  "iyun",
  "iyul",
  "avg",
  "sen",
  "okt",
  "noy",
  "dek",
];

const getMonthShortName = (month) => {
  const monthIndex = parseInt(String(month || "").slice(5, 7), 10) - 1;

  return MONTH_SHORT_NAMES[monthIndex] || "";
};

const getDayFromDate = (date) => {
  const value = String(date || "");
  const isoMatch = value.match(/^\d{4}-\d{2}-(\d{2})/);
  const dottedMatch = value.match(/^(\d{1,2})\.\d{1,2}\.\d{4}$/);
  const compactMatch = value.match(/^\d{8}$/);

  if (isoMatch) {
    return isoMatch[1];
  }

  if (dottedMatch) {
    return dottedMatch[1];
  }

  if (compactMatch) {
    return value.slice(6, 8);
  }

  return value.slice(6, 8);
};

const formatDateLabel = (month, date) => {
  const day = parseInt(getDayFromDate(date), 10);

  if (!day) {
    return "";
  }

  return `${day} ${getMonthShortName(month)}`.trim();
};

const formatEditDate = (month, date) => {
  const day = String(getDayFromDate(date)).padStart(2, "0");

  return `${month}-${day}`;
};

const getRowMonth = (month, row) => row?.__month || month;
const getRowDate = (row) => row?.__date || row?.sana;

const formatTableValue = (value) => {
  return value === null || value === undefined || value === "" ? "-" : value;
};

const Table4 = ({ month, data, setDate, isRange = false }) => {
  const conponentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });
  
  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'></div>

        <ul className='table-top-right'>
          {user_data() ? (
            user_data().region_id == 9 || user_data().region_id == 16 ? (
              <li>
                <NavLink
                  to='/oqjarqizilqishloq/add'
                  className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                  Ma'lumot kiritish&nbsp;&nbsp;&nbsp;
                  <PlusOutlined />
                </NavLink>
              </li>
            ) : null
          ) : null}
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf(OQJAR_TABLE_ID)} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint(OQJAR_EXPORT_NAME, month, OQJAR_TABLE_ID)
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead'>
        <div ref={conponentPDF} style={{ width: "100%" }}>
          <table className='table table-bordered table-style' id={OQJAR_TABLE_ID} data-excel-range={isRange ? "true" : undefined}>
            <thead>
              <tr className='oqjar-title-row'>
                <th colSpan={13} scope='col'>
                  {OQJAR_TABLE_TITLE}
                </th>
              </tr>

              <tr>
                <th rowSpan={2} scope='col' className='sticky st1'>
                  Sana
                </th>

                <th rowSpan={2} scope='col'>
                  Oqjar
                </th>

                <th rowSpan={2} scope='col'>
                  Qizil qishloq
                </th>

                <th rowSpan={2} scope='col'>
                  Reyka №1 <br />
                  (sm)
                </th>

                <th rowSpan={2} scope='col'>
                  Reyka №5 <br />
                  (sm)
                </th>

                <th colSpan={2} scope='col'>
                  Tojikiston
                </th>

                <th colSpan={2} scope='col'>
                  Toshkent viloyati
                </th>

                <th rowSpan={2} scope='col'>
                  JMMK
                </th>

                <th rowSpan={2} scope='col'>
                  Do’stlik kanali
                </th>

                <th colSpan={2} scope='col'>
                  Shundan
                </th>
              </tr>

              <tr>
                <th scope='col'>NS zafar quy. Qayr</th>
                <th scope='col'>YUDK</th>
                <th scope='col'>QDK</th>
                <th scope='col'>Bekobod</th>
                <th scope='col'>O’zbekiston</th>
                <th scope='col'>Qozog’iston</th>
              </tr>
            </thead>

            {data.length > 0
              ? data.map((d, i) => {
                  return (
                    <tbody key={i}>
                      <tr className='oqjar-main-row'>
                        <th
                          className=''
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                          rowSpan={2}>
                          {user_data() ? (
                            user_data().region_id == 9 ||
                            user_data().region_id == 16 ? (
                                <NavLink
                                  style={{
                                    color: "#222"
                                  }}
                                to='/oqjarqizilqishloq/add'
                                onClick={() =>
                                  setDate(formatEditDate(getRowMonth(month, d), getRowDate(d)))
                                }>
                                {formatDateLabel(getRowMonth(month, d), getRowDate(d))}
                              </NavLink>
                            ) : (
                              <span>
                                {formatDateLabel(getRowMonth(month, d), getRowDate(d))}
                              </span>
                            )
                          ) : (
                            <span>
                              {formatDateLabel(getRowMonth(month, d), getRowDate(d))}
                            </span>
                          )}
                        </th>

                        <th className='text-center'>{formatTableValue(d.oqjar1)}</th>

                        <th className='text-center'>{formatTableValue(d.qizil1)}</th>

                        <th
                          className='text-center'
                          rowSpan={2}
                          style={{ verticalAlign: "middle" }}>
                          {formatTableValue(d.reka1)}
                        </th>

                        <th
                          className='text-center'
                          rowSpan={2}
                          style={{ verticalAlign: "middle" }}>
                          {formatTableValue(d.reka5)}
                        </th>

                        <th className='text-center'>{formatTableValue(d.ns)}</th>
                        <th className='text-center'>{formatTableValue(d.yudk1)}</th>
                        <th className='text-center'>{formatTableValue(d.kdk1)}</th>
                        <th className='text-center'>{formatTableValue(d.bekobod1)}</th>
                        <th className='text-center'>{formatTableValue(d.jmmk1)}</th>
                        <th className='text-center'>{formatTableValue(d.dostlik1)}</th>
                        <th className='text-center'>{formatTableValue(d.uzb1)}</th>
                        <th className='text-center'>{formatTableValue(d.kz1)}</th>
                      </tr>

                      <tr className='oqjar-sub-row'>
                        <th className='text-center'>{formatTableValue(d.oqjar2)}</th>
                        <th className='text-center'>{formatTableValue(d.qizil2)}</th>
                        <th className='text-center'>{formatTableValue(d.ns1)}</th>
                        <th className='text-center'>{formatTableValue(d.yudk2)}</th>
                        <th className='text-center'>{formatTableValue(d.kdk2)}</th>
                        <th className='text-center'>{formatTableValue(d.bekobod2)}</th>
                        <th className='text-center'>{formatTableValue(d.jmmk2)}</th>
                        <th className='text-center'>{formatTableValue(d.dostlik2)}</th>
                        <th className='text-center'>{formatTableValue(d.uzb2)}</th>
                        <th className='text-center'>{formatTableValue(d.kz2)}</th>
                      </tr>
                    </tbody>
                  );
                })
              : Array.from({ length: 18 }).map((_, i) => (
                  <tbody key={i}>
                    <tr className='oqjar-main-row'>
                      <th
                        className='text-center'
                        rowSpan={2}
                        style={{ verticalAlign: "middle" }}></th>

                      <th className='text-center'></th>
                      <th className='text-center'></th>

                      <th
                        className='text-center'
                        rowSpan={2}
                        style={{ verticalAlign: "middle" }}></th>

                      <th
                        className='text-center'
                        rowSpan={2}
                        style={{ verticalAlign: "middle" }}></th>

                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                    </tr>

                    <tr className='oqjar-sub-row'>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                      <th className='text-center'></th>
                    </tr>
                  </tbody>
                ))}
          </table>
        </div>
      </div>
    </>
  );
};
export default Table4;
